import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import ContactApi from "../Api/ContactApi";
import { formatDate } from "../helper/DateHelper";
import TablePagination from "./TablePagination";

const ContactListLayer = () => {
    const [enquiries, setEnquiries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);

    const fetchEnquiries = async () => {
        setLoading(true);
        try {
            const params = {
                page,
                limit: rowsPerPage
            };
            const res = await ContactApi.list(params);
            if (res.status && res.response) {
                setEnquiries(res.response.data || []);
                setTotalCount(res.response.total || 0);
            }
        } catch (error) {
            console.error("Error fetching contact enquiries:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEnquiries();
    }, [page, rowsPerPage]);

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden shadow-sm border-0">
            <div className="card-header border-bottom bg-base py-16 px-24">
                <h6 className="text-primary-600 pb-2 mb-0 d-flex align-items-center gap-2">
                    {/* <Icon icon="solar:letter-bold-duotone" className="text-2xl" /> */}
                    Contact Us
                </h6>
            </div>

            <div className="card-body p-24">
                <div className="table-responsive">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr className="bg-neutral-50 ">
                                <th scope="col" className="text-center py-16" style={{ width: '80px', color: "black", fontWeight: '600' }}>S.No</th>
                                <th scope="col" className="py-16" style={{ color: "black", fontWeight: '600' }}>Full Name</th>
                                <th scope="col" className="py-16" style={{ color: "black", fontWeight: '600' }}>Contact Details</th>
                                <th scope="col" className="py-16" style={{ color: "black", fontWeight: '600' }}>Message</th>
                                <th scope="col" className="py-16" style={{ color: "black", fontWeight: '600' }}>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="5" className="text-center py-100">
                                        <div className="spinner-border text-primary-600" role="status"></div>
                                    </td>
                                </tr>
                            ) : enquiries.length > 0 ? (
                                enquiries.map((item, index) => (
                                    <tr key={item._id}>
                                        <td className="text-center text-sm fw-medium text-secondary-light">
                                            {page * rowsPerPage + index + 1}
                                        </td>
                                        <td>
                                            <span className="text-sm fw-bold text-secondary-light">{item.fullName}</span>
                                        </td>
                                        <td>
                                            <div className="d-flex flex-column gap-1">
                                                <span className="text-sm text-secondary-600 d-flex align-items-center gap-1">
                                                    <Icon icon="solar:letter-bold" className="text-xs" />
                                                    {item.email}
                                                </span>
                                                <span className="text-sm text-secondary-600 d-flex align-items-center gap-1">
                                                    <Icon icon="solar:phone-bold" className="text-xs" />
                                                    {item.mobileNumber}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <p className="text-md text-secondary-light mb-0" style={{ maxWidth: '300px', whiteSpace: 'normal', fontSize: '14px !important', fontWeight: 600 }}>
                                                {item.message}
                                            </p>
                                        </td>
                                        <td>
                                            <span className="text-sm text-secondary-light fw-medium">{formatDate(item.createdAt)}</span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center py-100 italic text-secondary-400">
                                        No enquiries found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {!loading && totalCount > 0 && (
                    <div className="mt-24">
                        <TablePagination
                            currentPage={page}
                            totalPages={Math.ceil(totalCount / rowsPerPage)}
                            onPageChange={(p) => setPage(p)}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={(e) => {
                                setRowsPerPage(parseInt(e.target.value));
                                setPage(0);
                            }}
                            totalRecords={totalCount}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContactListLayer;
